import { render } from "./findpeople.vue?vue&type=template&id=f1de07fe&scoped=true"
import script from "./findpeople.vue?vue&type=script&lang=js"
export * from "./findpeople.vue?vue&type=script&lang=js"

import "./findpeople.vue?vue&type=style&index=0&id=f1de07fe&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1de07fe"]])

export default __exports__